"use client";
import React, { useEffect } from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

type PropType = {
  slides: number[];
  options?: EmblaOptionsType;
};

const IndexCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [emblaRef] = useEmblaCarousel(options, [
    Autoplay({ playOnInit: true, delay: 3000, stopOnInteraction: false }),
  ]);

  return (
    <div className="embla w-[300px] overflow-hidden" ref={emblaRef}>
      <div className="embla__container flex">
        {slides.map((index) => (
          <div className="embla__slide w-[300px] shrink-0" key={index}>
            <img src={`/mockups/mockup${index + 1}.png`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndexCarousel;
